import { ApolloClient, ApolloClientOptions } from 'apollo-client';
import { NormalizedCacheObject } from 'apollo-cache-inmemory';

// This class is used extends the ApolloClient class, to add the toJSON method to handle JSON.stringify in SampleApp
// and other implementations.
export class SafeApolloClient extends ApolloClient<NormalizedCacheObject> {
    constructor(options: ApolloClientOptions<NormalizedCacheObject>) {
        super(options);
    }

    toJSON() {
        return {
            type: 'ApolloClient',
            queryDeduplication: this.queryDeduplication
        };
    }
}
